export function canEdit(config: any, authContext: any) {
  if (!config) throw new Error('missing config');
  if (!authContext) throw new Error('missing authContext');
  const { editRestrictions } = config;
  if (!editRestrictions) return true;
  if (editRestrictions.requiresSuperuser) return authContext.isSuperuser();
  if (editRestrictions.requiresAdmin) return authContext.isAdmin();
  return true;
}
